import { createColumnDate, createColumnInput, createColumnSelect } from "../../../components/table/c-table.logic";
import i18n from "../../../i18n";
import store from "../../../store/index";
import lodash from "lodash";
import {
    createFieldAttachment, createFieldDate,
    createFieldRadioGroup,
    createFieldTemplateBuilder,
    createFieldTextArea
} from "../../../components/input/template-builder/template-builder.logic";
import { conditionFormChecker, putField } from "../../../utils/form";

import { defineAsyncComponent } from "vue";
import { createButton } from "../../../utils/button";
import { createButtonDropdown } from "../../../utils/dropdown";
import { onClickReport } from "../../../utils/page";
import { callReports } from "../license-request/request/license/request-license.logic";
import { Modal } from "ant-design-vue";
import router from "../../../router";
import { have } from "../../../utils/menu-context";
import {
    createFieldAttorney, createFieldCancelRequest, createFieldFishingArea,
    createFieldLicenseOwner,
    createFieldRequestDetail, createFieldWorker
} from "../license-request/request/license/request-license.section";
import { callRequestType } from "../license-request/request/request.section";
import { createReportRevokeLicense } from "../license-request/request/request.report";

const CIcon = defineAsyncComponent(() => import("../../../components/icon/CIcon"));


export const callReceiverDepartment = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/department/cacheFindAllReceiverDepartment", { searchQuery });

export const callLicenseStatus = () =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "LICENSE_STATUS" });

export const callPrintStatus = () =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PRINT_STATUS" });

export const callProposeRevokeStatus = () =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PROPOSE_REVOKE_STATUS" });

export const callAppealStatus = () =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "APPEAL_STATUS" });

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.licenseRequest.licenseCode"),
            dataIndex: "licenseCode",
            width: 140,
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.licenseRequest.owner"),
            dataIndex: "ownerName",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.licenseRequest.approveDate"),
            dataIndex: "approveDate",
            width: 100,
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.license.licenseIssueDate"),
            dataIndex: "licenseIssueDate",
            width: 100,
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.license.licenseExpiredDate"),
            dataIndex: "licenseExpiredDate",
            width: 100,
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refIssueLicenseDept"),
            dataIndex: "refReceiveDept.nameTh",
            inputProp: () => ({ list: callReceiverDepartment, optLabel: "nameTh" }),
            search: { name: "refReceiveDept.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refPrintStatus"),
            dataIndex: "refPrintStatus.value",
            inputProp: () => ({ list: callPrintStatus, optLabel: "value" }),
            search: { name: "refPrintStatus.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refLicenseStatus"),
            dataIndex: "refLicenseStatus.value",
            inputProp: () => ({ list: callLicenseStatus, optLabel: "value" }),
            search: { name: "refLicenseStatus.id" }
        }),
        createColumnSelect({
            visible: () => false,
            title: () => i18n.global.t("model.licenseRequest.refRequestType"),
            dataIndex: "refRequestType.value",
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" }
        }),
    ];
    return columns;
};


export const createReportItems = ({ props, modelRef }) => {
    const { menuContext, routerPrefix } = props
    return [
        // ...createReportFishingLicense({ props, modelRef, id }),
        {
            visible: () => true,
            text: i18n.global.t("views.report.fishingLicenseDraft"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () =>
                        callReports({ data: { reportName: "fishingLicense", licenseRequest: { id: modelRef?.id }, isDraft: true, isThaiNumber: true } }),
                    fileName: `fishingLicense_${modelRef.licenseCode}.pdf`
                });
            },
        },
        {
            visible: () => ["approve"].includes(modelRef?.refStatus?.key)
                && ["waitPrintedLicense"].includes(modelRef?.refPrintStatus?.key)
                && have({menuContext, keys: ["canActionInAmphur", "canActionInProvince", "forDofCenter", "forAuthorized", "forReview"]}),
            text: i18n.global.t("views.report.fishingLicenseReal"),
            icon: "license.svg",
            onClick: () => Modal.confirm({
                title: i18n.global.t("views.report.confirmPrintLicense"),
                autoFocusButton: "cancel",
                onOk: () => {
                    onClickReport({
                        callReport: () => callReports({ data: { reportName: "fishingLicense", licenseRequest: { id: modelRef?.id }, isDraft: false, isConfirmPrint: true, isThaiNumber: true } }),
                        fileName: `fishingLicense_${modelRef.licenseCode}.pdf`
                    }).then(() => {
                        console.log('routerPrefix', routerPrefix)
                        router.push({ name: `${routerPrefix}-view`, params: { id: modelRef.id }, query: { _timestamp: new Date().getTime() } })
                    });
                },
            }),
        },
        ...createReportRevokeLicense({ props, modelRef, id: modelRef?.id }),
    ]
};

export const createFieldLicenseDetail = ({ props, data, key }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    return putField({
        data,
        fields: [
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: "licenseIssueDate",
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.license.licenseIssueDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: modelRef.licenseIssueDate,
                            "onUpdate:value": (value) => (modelRef.licenseIssueDate = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: "licenseExpiredDate",
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.license.licenseExpiredDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: modelRef.licenseExpiredDate,
                            "onUpdate:value": (value) => (modelRef.licenseExpiredDate = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
        ],
    });
};

export const createField = ({ props, data, key, isLoading }) => {
    // const { viewOnly, menuContext } = props;
    // const { useForm } = data;
    // const { modelRef } = useForm;
    // const model = key ? lodash.get(modelRef, key) : modelRef;
    // const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            ...createFieldLicenseDetail({ props, data, key }),
            ...createFieldRequestDetail({ props, data, key }),
            ...createFieldLicenseOwner({ props, data, key, isLoading }),
            ...createFieldAttorney({ props, data, key }),
            ...createFieldFishingArea({ props, data, key }),
            ...createFieldWorker({ props, data, key}),
            ...createFieldCancelRequest({ props, data, key }),
        ],
    });
};

export const createFieldProposeRevoke = ({ props, data, key, isLoading }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}proposeRevoke`,
                cardBorderProp: () => ({ title: i18n.global.t("views.license.proposeRevoke"), headerSize: "small" }),
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                colProp: () => ({ xs: 24, class: "mt-3" }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldRadioGroup({
                            visible: ({ field }) => conditionFormChecker({
                                props,
                                data,
                                executeKey: "visibleField",
                                params: { field }
                            }),
                            key: `${prefix}refProposeRevokeStatus`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.license.refProposeRevokeStatus"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refProposeRevokeStatus,
                                        "onUpdate:value": value => {
                                            model.refProposeRevokeStatus = value;
                                        },
                                        disabled: viewOnly,
                                        list: callProposeRevokeStatus,
                                        optLabel: "value"
                                    },
                                    conditionFormChecker({
                                        props,
                                        data,
                                        executeKey: "inputPropField",
                                        params: { field }
                                    })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({
                                props,
                                data,
                                executeKey: "visibleField",
                                params: { field }
                            }),
                            key: `${prefix}proposeRevokeRemark`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("model.license.proposeRevokeRemark"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.proposeRevokeRemark,
                                        "onUpdate:value": value => (model.proposeRevokeRemark = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({
                                        props,
                                        data,
                                        executeKey: "inputPropField",
                                        params: { field }
                                    })
                                )
                        }),
                        createFieldAttachment({
                            key: `${prefix}attachmentProposeRevokes`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.license.attachmentProposeRevokes"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.attachmentProposeRevokes,
                                        "onUpdate:value": value => modelRef.attachmentProposeRevokes = value,
                                        disabled: viewOnly,
                                        multiple: true,
                                        group: "ProposeRevokeAttachment"
                                    },
                                    conditionFormChecker({
                                        props,
                                        data,
                                        executeKey: "inputPropField",
                                        params: { field }
                                    })
                                )
                        })
                    ]}),
                    skeleton: isLoading.value
                })
            })
        ]
    });
};



export const createFieldLicenseCondition = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                key: `${prefix}licenseConditionRemark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                // label: () => i18n.global.t("model.license.licenseConditionRemark"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.licenseConditionRemark,
                            "onUpdate:value": value => (model.licenseConditionRemark = value),
                            disabled: viewOnly,
                            rows: 8
                        },
                        conditionFormChecker({
                            props,
                            data,
                            executeKey: "inputPropField",
                            params: { field }
                        })
                    )
            }),
        ]
    });
};


export const createFieldLicenseStatus = ({ props, data, key, isLoading, visibleStatus, title, invisibleFields = [], fieldKey }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}${fieldKey}`,
                cardBorderProp: () => ({ title: title, headerSize: "small" }),
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                colProp: () => ({ xs: 24, class: "mt-3" }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldRadioGroup({
                            key: `${prefix}refLicenseStatus`,
                            visible: ({ field }) => conditionFormChecker({
                                props,
                                data,
                                executeKey: "visibleField",
                                params: { field }
                            }),
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.license.refLicenseStatus"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refLicenseStatus,
                                        "onUpdate:value": value => {
                                            model.refLicenseStatus = value;
                                        },
                                        disabled: viewOnly,
                                        list: () => callLicenseStatus().then(array => {
                                            return array.filter(it => visibleStatus.includes(it.key));
                                        }),
                                        optLabel: "value"
                                        // renderLabel: ({ item }) => <span>{ item.key != "active" ? item.value: "ยกเลิกเพิกถอน" }</span>,
                                    },
                                    conditionFormChecker({
                                        props,
                                        data,
                                        executeKey: "inputPropField",
                                        params: { field }
                                    })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({
                                props,
                                data,
                                executeKey: "visibleField",
                                params: { field }
                            }) && !invisibleFields.includes(field.key),
                            key: `${prefix}licenseRevokeRemark`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("model.license.licenseRevokeRemark"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.licenseRevokeRemark,
                                        "onUpdate:value": value => (model.licenseRevokeRemark = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({
                                        props,
                                        data,
                                        executeKey: "inputPropField",
                                        params: { field }
                                    })
                                )
                        }),
                        createFieldAttachment({
                            visible: ({ field }) => conditionFormChecker({
                                props,
                                data,
                                executeKey: "visibleField",
                                params: { field }
                            }) && !invisibleFields.includes(field.key),
                            key: `${prefix}attachmentRevokes`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.license.attachmentRevokes"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.attachmentRevokes,
                                        "onUpdate:value": value => modelRef.attachmentRevokes = value,
                                        disabled: viewOnly,
                                        multiple: true,
                                        group: "RevokeAttachment"
                                    },
                                    conditionFormChecker({
                                        props,
                                        data,
                                        executeKey: "inputPropField",
                                        params: { field }
                                    })
                                )
                        })
                    ]}),
                    skeleton: isLoading.value
                })
            })
        ]
    });
};


// export const createFieldAdminCommand = ({ props, data, key, isLoading }) => {
//     const { viewOnly } = props;
//     const { useForm } = data;
//     const { modelRef } = useForm;
//     const model = key ? lodash.get(modelRef, key) : modelRef;
//     const prefix = key ? `${key}.` : "";
//     return putField({
//         data,
//         fields: [
//             {
//                 key: `${prefix}suspendedLicense`,
//                 visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
//                 colProp: () => ({ xs: 24, md: 12, class: "text-right" }),
//             }
//         ]
//     })
// }

export const createFieldAppealLicense = ({ props, data, key, isLoading }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}appealLicense`,
                cardBorderProp: () => ({ title: i18n.global.t("views.section.appellant"), headerSize: "small" }),
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24, class: "mt-3" }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldRadioGroup({
                            key: `${prefix}refAppealLicenseStatus`,
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.license.refAppealLicenseStatus"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refAppealLicenseStatus,
                                        "onUpdate:value": value => {
                                            model.refAppealLicenseStatus = value;
                                        },
                                        disabled: viewOnly,
                                        list: () => callAppealStatus(),
                                        optLabel: "value"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}appealLicenseRemark`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("model.license.appealLicenseRemark"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.appealLicenseRemark,
                                        "onUpdate:value": value => (model.appealLicenseRemark = value),
                                        disabled: viewOnly,
                                        placeholder: i18n.global.t("model.licenseRequest.appealRequestRemarkPlaceholder")
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldAttachment({
                            key: `${prefix}attachmentAppealLicenses`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.license.attachment"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.attachmentAppealLicenses,
                                        "onUpdate:value": value => modelRef.attachmentAppealLicenses = value,
                                        disabled: viewOnly,
                                        multiple: true,
                                        group: "AppealAttachment"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        })
                    ]}),
                    skeleton: isLoading.value
                })
            })
        ]
    })
}

export const createButtonPrintReport = ({ onClick, isLabel = true, classStyle = "", options }) => {
    return createButton(
        lodash.merge(
            {
                size: "large",
                isLabel,
                text: i18n.global.t("button.printLicense"),
                classStyle: "c-btn-save btn-primary " + classStyle,
                onClick,
                icon: <CIcon file="license.svg"></CIcon>,
            },
            options
        )
    );
};

export const createFieldPrintStatus = ({ props, data, key, visibleStatus, isLoading }) => {
    const { menuContext, viewOnly, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [

            createFieldTemplateBuilder({
                key: `${prefix}printLicense`,
                cardBorderProp: () => ({ title: i18n.global.t("views.section.printLicense"), headerSize: "small" }),
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24, class: "mt-3" }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldRadioGroup({
                            key: `${prefix}refPrintStatus`,
                            visible: ({ field }) => conditionFormChecker({
                                props,
                                data,
                                executeKey: "visibleField",
                                params: { field }
                            }),
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.license.refPrintStatus"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refPrintStatus,
                                        "onUpdate:value": value => {
                                            model.refPrintStatus = value;
                                        },
                                        disabled: viewOnly,
                                        list: () => callPrintStatus().then(array => {
                                            return array.filter(it => visibleStatus.includes(it.key));
                                        }),
                                        optLabel: "value"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        {
                            key: `${prefix}printLicenseBtn`,
                            // visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            visible: () => false,
                            colProp: () => ({ xs: 24, md: 12, class: "text-right" }),
                            formItemRender: () => createButtonDropdown({
                                size: "large",
                                text: i18n.global.t("button.printLicense"),
                                classStyle: "c-btn-save btn-primary ",
                                icon: <CIcon file="license.svg"></CIcon>,
                                items: [
                                    {
                                        visible: () => true,
                                        text: i18n.global.t("views.report.fishingLicenseDraft"),
                                        icon: "pdf.svg",
                                        onClick: () => {
                                            onClickReport({
                                                callReport: () => callReports({ data: { reportName: "fishingLicense", licenseRequest: { id: model?.id }, isDraft: true, isThaiNumber: true } }),
                                                fileName: `fishingLicense_${model.licenseCode}.pdf`
                                            });
                                        },
                                    },
                                    {
                                        visible: () => ["approve"].includes(modelRef?.refStatus?.key)
                                            && ["waitPrintedLicense"].includes(modelRef?.refPrintStatus?.key)
                                            && have({menuContext, keys: ["canActionInAmphur", "canActionInProvince", "forDofCenter", "forAuthorized", "forReview"]}),
                                        text: i18n.global.t("views.report.fishingLicenseReal"),
                                        icon: "license.svg",
                                        onClick: () => Modal.confirm({
                                            title: i18n.global.t("views.report.confirmPrintLicense"),
                                            autoFocusButton: "cancel",
                                            onOk: () => {
                                                onClickReport({
                                                    callReport: () => callReports({ data: { reportName: "fishingLicense", licenseRequest: { id: model?.id }, isDraft: false, isConfirmPrint: true, isThaiNumber: true } }),
                                                    fileName: `fishingLicense_${model.licenseCode}.pdf`
                                                }).then(() => router.push({ name: `${routerPrefix}-view`, params: { id: modelRef.id }, query: { _timestamp: new Date().getTime() } }));
                                            },
                                        }),
                                    },
                                ],
                            })
                        },
                    ]}),
                    skeleton: isLoading.value
                })
            })
        ]
    });
};

export const createLogAdminCommandDetail = ({ data, key }) => {
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                key: `${prefix}refLicenseStatus`,
                label: () => i18n.global.t("model.license.refLicenseStatus"),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            },
            {
                key: `${prefix}licenseRevokeRemark`,
                label: () => i18n.global.t("model.license.licenseRevokeRemark"),
                changeLog: { getValue: ({ record }) => record.licenseRevokeRemark },
            },
            {
                key: `${prefix}refProposeRevokeStatus`,
                label: () => i18n.global.t("model.license.refProposeRevokeStatus"),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            },
            {
                key: `${prefix}proposeRevokeRemark`,
                label: () => i18n.global.t("model.license.proposeRevokeRemark"),
                changeLog: { getValue: ({ record }) => record.proposeRevokeRemark },
            },
        ],
    });
};